module.exports = __webpack_public_path__ + "7c49be801c5d0aec88180e97cc34bea8.jpg";


//////////////////
// WEBPACK FOOTER
// ./assets/images/photo-backgrounds/places-to-hang-out-after-school/IceCreamParlor1.jpg
// module id = 3370
// module chunks = 0